import axios from 'axios';
import { TResFemaleRanking } from 'types/ranking';

const getFemaleRanking = async (params?: {
  areaId?: number;
}): Promise<TResFemaleRanking> => {
  const response = await axios.get('/ranking/female/male-view', {
    params: { area: params?.areaId },
  });

  return response.data;
};

export { getFemaleRanking };
